import constants from '../../constants/constants'

export default {
    moveDirections: [constants.MOVE_DIRECTIONS.VERTICAL],
    resizableSides: [constants.RESIZE_SIDES.TOP, constants.RESIZE_SIDES.BOTTOM],
    fullWidth: true,
    fullWidthByStructure: true,
    styleCanBeApplied: true,
    mobileConversionConfig: {
        isScreenWidth: true,
        filterChildrenWhenHidden: true,
        preserveAspectRatio: false
    }
}
